import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 16C07036-EE56-4447-8495-EB2FAD143072
 * name code-equal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-equal.svg
 * tags
 * - Developer / Languages 
 */
export const CodeEqualIcon = createSvgIcon(<><path d="M6,13H11V15H6M13,13H18V15H13M13,9H18V11H13M6,9H11V11H6M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z" /></>, 'CodeEqualIcon');
export default CodeEqualIcon